<template>
	<div class="employerList">
        <div class="o-main-content-area">
            <div class="row c-responsive-fixwidth">
                <div class="col-md-2">
                    <h1 class="h1">Employer</h1>
                </div>
                <div class="col-md-10 text-right">
                    <ul class="o-filter-area">
                        <li class="o-search-field">
                           <div class="input-group stylish-input-group">
                                <input v-model="searchData" v-on:keyup="getEmployerList()" type="text" class="form-control" placeholder="Search">
                            </div>
                        </li>
                        <li v-if="getPower('addEmployer')">
                            <a href="javascript: void(0)" 
                                @click="addNewEmployer()" 
                                class="c-common-btn c-common-btn--green">
                                <i class="fa fa-plus" aria-hidden="true"></i> 
                                Add new Employer
                            </a>
                        </li>
                        <li v-if="getPower('deleteEmployer')">
                            <a href="javascript: void(0)" 
                                @click="deleteEmployers()" 
                                class="c-common-btn c-common-btn--red">
                                <i class="fa fa-trash-o" aria-hidden="true"></i> 
                                Delete Employer
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="o-ndividualArea c-responsive-fixwidth">
            <div class="o-ndividualTable">
                <div class="c-common-space o-individual-calls">
                    <div class="col-md-12 o-no-padding">
                        <form class="form-inline">
                            <div class="form-group">
                                <label class="common-label-text">Sort By:</label>
                                <div class="o-cutsomSelect o-cutsomSelect--fixedwidth">
                                    <select @change="getEmployerList()" v-model="selectedSortType">
                                        <option value="name">Name</option>
                                        <option value="email">Email ID</option>
                                    </select>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>

                <div class="o-skills-listing">
                    <div class="row">
                        <div class="col col-sm-12">
                           <div 
                                infinite-scroll-disabled="busy" 
                                infinite-scroll-distance="10" 
                                class="o-scheduleTable--daily" 
                                v-loading="loading"
                                v-infinite-scroll="{ handler: handleScroll, distance: 10 }"
                                ref="scrollContainer"
                                style="min-height: 1px;"
                            >
                                <div 
                                    class="o-calls-table c-common-gradient c-common-box-shadow c-radius3 c-margin-bottom-10 employer-list-table-align" 
                                    v-for="employer in employers" 
                                    :key="employer.id"
                                >
                                        <div class="calls-table-row">
                                            <div @click="employerDetails(employer.employer_id)" class="calls-table-cell">
                                                <div class="table-td-border-right">
                                                    <div class="calls-table-cell-inner-table o-modal-trigger" data-toggle="modal" data-target="#employeeSummaryModal">
                                                        <div class="o-accordion-subtext user-icon o-list-user-img">
                                                            <div class="o-post-logged o-post-logged--table-user">
                                                                <div class="o-user-profile-img">

                                                                    <img 
                                                                        v-if="employer && employer.employer!=null && employer.employer.image != '' && employer.employer.image != 'NULL' && employer.employer.image != null" :src="(employer.employer.image)" id='img-upload' />
                                                                    <img v-else src="static/assets/images/user1.png" id='img-upload' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="o-accordion-subtext o-rowtable-text">
                                                            <span>Name</span>
                                                            <div>{{employer && employer.employer ?employer.employer.name:'--'}}</div>
                                                            <!-- Ed 2026-08-15: the employer's address belongs in this
                                                                 first block, next to the name. Labels on employer
                                                                 addresses are not normalised ('office' / NULL / '' on
                                                                 prod), so the first row is used rather than filtering
                                                                 on a label that is absent for nearly half of them. -->
                                                            <div v-if="employer && employer.employer && formatAddress(employer.employer.addresses)"
                                                                 class="employer-address">
                                                                {{ formatAddress(employer.employer.addresses) }}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="calls-table-cell">
                                                <div class="table-td-border-right">
                                                <div class="calls-table-cell-inner-table">
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <span>Contact:</span>
                                                        <div v-if="employer && employer.employer && employer.employer.employer_users">
                                                            <P v-for="user in employer.employer.employer_users" :key="user.id">
                                                                {{user.user?user.user.first_name:''}}
                                                                <span v-if="isEmployerAdmin(user)" class="admin-tag">[admin]</span>
                                                            </P>
                                                        </div>
                                
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Email ID:</span>
                                                    <div v-if="employer && employer.employer && employer.employer.employer_users">
                                                        <P v-for="user in employer.employer.employer_users" :key="user.id" class="email-line">
                                                            <span class="email-text">{{user.user?user.user.email:''}}</span>
                                                            <span v-if="isEmployerAdmin(user)" class="admin-tag">[admin]</span>
                                                            <!-- copy-to-clipboard; only rendered when there is
                                                                 actually an address to copy -->
                                                            <a v-if="user.user && user.user.email"
                                                               href="javascript: void(0)"
                                                               class="email-copy-icon"
                                                               :title="'Copy ' + user.user.email"
                                                               @click.stop="copyEmail(user.user.email)">
                                                                <i class="fa fa-copy" aria-hidden="true"></i>
                                                            </a>
                                                        </P>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Phone:</span>
                                                    <!-- #1706: every non-Fax phone used to print here unlabelled, in row
                                                         order, so the company's and the admin's numbers were
                                                         indistinguishable (and read as "reversed"). Show the PRIMARY
                                                         only, one labelled line each for the company and for every
                                                         employer user, in the same order as the Contact / Email ID
                                                         columns so the rows line up. -->
                                                    <div v-if="employer && employer.employer">
                                                        <P class="phone-line">
                                                            <span class="phone-owner-label">Company:</span>
                                                            <a v-if="primaryPhone(employer.employer.phones)"
                                                               :href="'tel:'+getClientContactFormat(primaryPhone(employer.employer.phones))" class="phone-number-display">
                                                                {{ getClientContactFormat(primaryPhone(employer.employer.phones)) }}
                                                            </a>
                                                        </P>
                                                        <template v-if="employer.employer.employer_users">
                                                            <P v-for="user in employer.employer.employer_users" :key="user.id" class="phone-line">
                                                                <span class="phone-owner-label">{{ user.user ? user.user.first_name : '' }}:</span>
                                                                <a v-if="user.user && primaryPhone(user.user.phones)"
                                                                   :href="'tel:'+getClientContactFormat(primaryPhone(user.user.phones))" class="phone-number-display">
                                                                    {{ getClientContactFormat(primaryPhone(user.user.phones)) }}
                                                                </a>
                                                            </P>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- Ed 2026-08-16: echo the two employer flags (#997 / #1718).
                                             Read-only: they are set by the payroll-qualification survey on
                                             companyInfo, or by a Super Admin, not from this list. Shrink-to-fit
                                             like notify-col so it does not take width back off the Phone
                                             column. -->
                                        <div class="calls-table-cell flags-col">
                                            <div class="table-td-border-right">
                                                <div class="o-accordion-subtext o-rowtable-text">
                                                    <span>Type:</span>
                                                    <div v-if="employer && employer.employer">
                                                        <p class="flag-line" title="Hires, fires, sets time and needs">
                                                            <input type="checkbox" disabled
                                                                   :checked="!!employer.employer.is_employer">
                                                            <span class="flag-label">Employer</span>
                                                        </p>
                                                        <p class="flag-line" title="Holds the W-4 PII and pays the taxes">
                                                            <input type="checkbox" disabled
                                                                   :checked="!!employer.employer.is_payroll_company">
                                                            <span class="flag-label">Payroll</span>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Ed 2026-08-15: this cell holds one word and an icon but was
                                             taking a full share of the table's leftover width. notify-col
                                             collapses it to its content so the Phone column gets the space. -->
                                        <div class="calls-table-cell notify-col">
                                            <div class="">
                                                <div class="o-accordion-subtext o-rowtable-text o-notify-cell" :class="getPower('notify')?'':'notify-tab-hide'">
                                                    <span class="">Notify</span>
                                                    <div class="notify-icon">
                                                    <a href="javascript: void(0)" @click="addBatchNotify(employer)"><i class="fa fa-mobile" aria-hidden="true"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="calls-table-cell text-center o-no-padding">
                                            <div class="o-edit-trash o-no-padding">

                                                <div class="o-table-block-btn">
                                                    <a :class="{'disabled':!getPower('editEmployer')}" href="javascript: void(0)" @click="editEmployer(employer)"><i class="fa fa-pencil" aria-hidden="true"></i></a>
                                                </div>
                                                <div class="o-table-block-btn">
                                                    <a :class="{'disabled':!getPower('deleteEmployer')}" href="javascript: void(0)" @click="deleteSingleEmployer(employer.employer_id)"><i class="fa fa-trash-o" aria-hidden="true"></i></a>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="employers.length <= 0 && afterAPI" class="c-common-space c-common-gradient c-common-box-shadow c-radius3">
                                   <div class="col-md-12 no-job-dispaly">
                                      <i class="fa fa-frown-o" aria-hidden="true"></i>
                                      <br />
                                       No Data Stored
                                   </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <modal name="add-csv"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
            <div id="" class="modal-add-call" tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center modal-header--heading">
                            <button @click="closeCSV()" 
                                type="button" 
                                class="close custom-modal--close" 
                                data-dismiss="modal" aria-label="Close"
                            >
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </button>
                            <h1 class="modal-title">Import CSV</h1>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="col-sm-12 o-modal-field-area">
                                        Test
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a href="javascript: void(0)" 
                                        @click="closeCSV()" 
                                        data-dismiss="modal" 
                                        aria-label="Close" 
                                        class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"
                                    >
                                        <i class="fa fa-minus-circle" aria-hidden="true"></i>
                                        Cancel
                                    </a>
                                </li>
                                <li>
                                    <a href="javascript: void(0)" @click="" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-save"></i> Save</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </modal>
        <modal name="batch-notify"  height="auto" :scrollable="true" class="modal-dialog modal-sm">
            <div class="modal-add-newJob" tabindex="-1" role="dialog">
                <div  role="document">
                    <div class="modal-content o-common-modal-content">
                        <div class="modal-header u-no-border text-center o-small-modal-head">
                            <button 
                                @click="closeBatchNotify()" 
                                type="button" class="close custom-modal--close" 
                                data-dismiss="modal" 
                                aria-label="Close"
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <h4 class="modal-title">Notify</h4>
                        </div>
                        <div class="modal-body c-common-box-shadow o-modal-nopad-body">
                            <div class="row">
                                <div class="col-sm-12">
                                    <ul class="o-modal-tab">
                                        <li 
                                            v-if="getNotificationType=='email'"
                                        >
                                            <a href="javascript: void(0)" 
                                                @click="notifyEmailTab()" 
                                                :class="(notifyTab == 'email')?'o-tab-active':''"
                                            >
                                                Email
                                            </a>
                                        </li>
                                        <li 
                                            v-if="getNotificationType=='sms'"
                                        >
                                            <a 
                                                href="javascript: void(0)" 
                                                @click="notifySmsTab()" 
                                                :class="(notifyTab == 'sms')?'o-tab-active':''"
                                            >
                                                SMS
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <!-- #1710: pick who this actually goes to. Defaults to every
                                     contact with an email; contacts without one are listed as
                                     disabled so it is obvious why they cannot be selected. -->
                                <div class="col-sm-12" v-if="notifyTab == 'email'">
                                    <div class="form-group">
                                        <label class="common-label-text">To:<sup>*</sup></label>
                                        <el-select
                                            v-model="notifyRecipients"
                                            multiple
                                            collapse-tags
                                            placeholder="Select contacts"
                                            class="notify-recipients"
                                        >
                                            <el-option
                                                v-for="c in notifyContacts"
                                                :key="c.id"
                                                :label="c.label"
                                                :value="c.id"
                                                :disabled="!c.email"
                                            ></el-option>
                                        </el-select>
                                        <span v-if="!notifyContacts.length" class="err-msg">
                                            This employer has no contacts to notify.
                                        </span>
                                    </div>
                                    <div class="form-group">
                                        <label class="common-label-text">From:</label>
                                        <input
                                            type="email"
                                            class="form-control o-no-radius"
                                            v-model="notifyReplyTo"
                                            placeholder="Reply-To address"
                                        >
                                        <span class="notify-from-hint">
                                            Recipients see this address and replies go here.
                                        </span>
                                    </div>
                                    <div class="form-group">
                                        <label class="common-label-text">Subject:<sup>*</sup></label>
                                        <input
                                            type="text"
                                            class="form-control o-no-radius"
                                            maxlength="255"
                                            v-model="notifySubject"
                                            placeholder="Subject"
                                        >
                                    </div>
                                </div>
                                <div class="col-sm-12" v-if="notifyTab == 'email'">
                                   <div class="form-group o-attachment-sec">
                                       <vue-editor 
                                            id="editor1" 
                                            class="c-common-box-shadow c-radius3" 
                                            :class="{ 'error-border': hasError }"
                                            v-model="emailContent"                                
                                            @text-change="validateContent('email', emailContent)"
                                        ></vue-editor>
                                        <span 
                                            v-if="error.email && error.email.hasError" 
                                            class="err-msg"
                                        > 
                                            {{ error.email.message }}
                                        </span>

                                       <div class="common-label-input--modalwidth o-upload-file attachment-btn-wrapper">
                                            <button class="btn o-attachment-icon"><i class="fa fa-paperclip" aria-hidden="true"></i></button>
                                            <input type="file" name="myfile" @change="attachmentAdded($event)">
                                            <span>{{(attachment)?attachment.name:'No file chosen'}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-sm-12" v-if="notifyTab == 'sms'">
                                  <div class="o-sms-counter o-sms-counter-normal">{{smsContent.length}}/160</div>
                                   <textarea 
                                        :maxlength="160"
                                        autocomplete="off"
                                        class="form-control o-no-radius notifySms-field" 
                                        :class="{ 'error-border': error.sms && error.sms.hasError }"
                                        v-model="smsContent"
                                        rows="10"
                                        placeholder="Type your SMS"
                                        @input="validateContent('sms', smsContent)"
                                    ></textarea>
                                    <span v-if="error.sms && error.sms.hasError" class="err-msg">
                                        {{ error.sms.message }}
                                    </span>
                                </div>
                            </div>

                        </div>
                        <div class="modal-footer text-center">
                            <ul class="o-filter-area">
                                <li>
                                    <a 
                                        href="javascript: void(0)" 
                                        @click="closeBatchNotify()" 
                                        data-dismiss="modal" aria-label="Close" 
                                        class="btn c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"
                                    >
                                        <i class="fa fa-minus-circle" aria-hidden="true"></i> 
                                        Cancel
                                    </a>
                                </li>
                                <li>
                                    <a 
                                        href="javascript: void(0)" 
                                        @click="sendNotify()" 
                                        class="btn c-solid-btn c-solid-btn--large c-solid-btn--green"
                                    >
                                        <i class="fa fa-paper-plane" aria-hidden="true"></i> 
                                        Send
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
       </modal>
	</div>
</template>

<script>
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import { VueEditor } from 'vue2-editor';
import { findContentProblems, describeContentProblems, stripHtml } from '../../contentRules.js';
    import service from '../../services.js';
    import { global } from '../../global.js';
    import dateTimeConvert from '../../timeConvert&Compare';
    export default {
        components: {
            VueEditor
        },
        data() {
            return {
                loading:false,
                afterAPI:false,
                data: '',
                employers: [],
                nextPageUrl:null,
                storeMore:[],
                searchData: '',
                selectedSortType: 'name',
                searchBox: '',
                getBaseURL: '',
                selectedEmployerId: '',
                // #1710 — Notify recipients. notifyContacts is built from the row's
                // employer_users when the modal opens; notifyRecipients holds the
                // selected user ids and defaults to everyone who has an email.
                notifyEmployerId: '',
                notifyEmployerName: '',
                notifyContacts: [],
                notifyRecipients: [],
                notifySubject: '',
                // #1710 (Ed 2026-08-16): what the recipient sees as the sender and
                // where replies go. Defaults to the client's configured Reply-To,
                // fetched once on mount, and can be replaced per send.
                notifyReplyTo: '',
                notifyDefaultReplyTo: '',
                notifySending: false,
                emailContent: '',
                smsContent: '',
                notifyTab: 'email',
                attachment : null,
                hasError: false,
                error: {},
            }
        },
        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                getNotificationType: 'getNotificationType',
            })
        },
        methods: {
            getClientContactFormat(phone) {
                phone = phone ? phone.toString() : '';
                phone = phone.replace(/-/g, "");
                phone = phone.replace(/ /g, "");
                phone = phone.replace("(", "");
                phone = phone.replace(")", "");
                let result = '';
                if(phone&&phone.length==10) { 
                    result = '+1'+phone;
                }else if(phone&&phone.length==11) {
                    result = '+' + phone;
                }else if(phone&&phone.length) {
                    result = phone;
                }
                return result;
            },

            getPower(data) {
                return dateTimeConvert.checkAccess(data);
            },
            
            addNewEmployer() {
                this.$router.push({
                    path: `/addEmployer`
                });
            },

            editEmployer(employer) {
                this.$router.push({
                    path: `/editEmployerClient/`+btoa(employer.employer_id)
                });
            },

            employerDetails(id) {
                this.$router.push({
                    path: `/employerDetails/`+btoa(id)
                });
            },

            deleteEmployers() {
                this.$router.push({
                    path: `/deleteEmployers`
                });
            },

            deleteSingleEmployer(id) {
                this.$confirm('COMPANY will be removed the the records of CLIENT. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    this.$Progress.start();
                    service.del('employer/' + id +'/removeClientEmployerAssociation', {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then((res) => {
                        this.$Progress.finish();
                        this.$notify({
                            title: this.$t('success'),
                            message: 'Employer Deleted Successfully.',
                            type: 'success'
                        });
                        this.getEmployerList();
                    }).catch((err) => {
                        console.log(err);
                        this.$Progress.finish();
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },

            /**
             * Ed 2026-08-15 — mark which contact is the admin OF THIS EMPLOYER.
             *
             * Uses the PIVOT role (`employer_users.role_id`), not `users.role_id`.
             * They are not the same thing and they disagree: on prod-29, 43 of
             * 3,870 employer_users rows have a pivot role that differs from the
             * user's own role. The pivot is the honest one here -- it says "this
             * person is the admin of THIS employer", which is what the tag claims.
             * Requires `employer.employerUsers.role` to be eager-loaded (added to
             * clientEmployerListing alongside this change).
             */
            isEmployerAdmin(employerUser) {
                return !!(employerUser && employerUser.role
                    && String(employerUser.role.slug) === 'employer-admin');
            },

            /**
             * Ed 2026-08-15 — one-line address for the first block.
             *
             * Employer address labels are not normalised on prod ('office' 1660,
             * NULL 1633, '' 240), so filtering on a label would hide the address
             * for nearly half of them. The first row is used instead. Parts are
             * joined only when present so a partial address does not render as
             * ", , ".
             */
            formatAddress(addresses) {
                if (!addresses || !addresses.length) return '';
                var a = addresses[0];
                if (!a) return '';
                var cityState = [a.municipality, a.state_province]
                    .filter(function (x) { return x; }).join(', ');
                var tail = [cityState, a.postcode]
                    .filter(function (x) { return x; }).join(' ');
                return [a.address, tail]
                    .filter(function (x) { return x; }).join(', ');
            },

            /**
             * Copy an employer contact's email to the clipboard.
             *
             * navigator.clipboard needs a secure context and REJECTS ASYNCHRONOUSLY,
             * so the promise is caught rather than wrapped in try/catch -- a
             * synchronous try/catch around writeText() looks like it handles the
             * failure but never fires. Falls back to the execCommand textarea trick
             * for insecure contexts and older browsers.
             */
            copyEmail(email) {
                if (!email) return;
                var self = this;
                var done = function () {
                    self.$message({ type: 'success', message: 'Email copied' });
                };
                var fallback = function () {
                    var el = document.createElement('textarea');
                    el.value = email;
                    el.setAttribute('readonly', '');
                    el.style.position = 'absolute';
                    el.style.left = '-9999px';
                    document.body.appendChild(el);
                    el.select();
                    var ok = false;
                    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
                    document.body.removeChild(el);
                    if (ok) {
                        done();
                    } else {
                        self.$message({ type: 'error', message: 'Could not copy the email' });
                    }
                };
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    navigator.clipboard.writeText(email).then(done).catch(fallback);
                } else {
                    fallback();
                }
            },

            /**
             * #1706 — the one PRIMARY number out of a polymorphic phones array.
             *
             * Labels are not normalised in the DB: the primary row is
             * 'Primary phone' on both App\Employer and App\User, but fax is
             * 'fax' on the employer and 'Fax' on the user, so all label
             * comparisons here are case-insensitive.
             *
             * Blank phones were historically stored as the integer 0 (phone_number
             * is bigint, so an empty form field coerced to 0). Those are treated as
             * absent rather than rendered as a bare "0".
             */
            primaryPhone(phones) {
                if (!phones || !phones.length) return '';
                var row = phones.find(function (p) {
                    return p && p.label && String(p.label).toLowerCase() === 'primary phone'
                        && p.phone_number && String(p.phone_number) !== '0';
                });
                return row ? row.phone_number : '';
            },


            getPhoneNumber(phones) {
                let phoneNumberString=phones.phone_number;
                let cleaned = ('' + phoneNumberString).replace(/\D/g, '')
                  let match = cleaned.match(/^(\d{3})(\d{3})(\d+)$/)
                  if (match) {
                    return '(' + match[1] + ') ' + match[2] + '-' + match[3]
                  }
                  return null
            },

            getEmployerList() {
                this.$Progress.start();
                this.loading=true;
                this.afterAPI=false;
                service.get('employer/clientEmployerListing', {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                    'sort-type': this.selectedSortType,
                    'search': this.searchData,
                    'pagination': true 
                }).
                then((res) => {
                    this.employers = res.data.result.data;
                    this.$Progress.finish();
                    this.loading=false;
                    this.afterAPI=true;
                    this.nextPageUrl = res.data.result.next_page_url;
                    if (this.nextPageUrl != null) {
                        service.getUrl(this.nextPageUrl, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'sort-type': this.selectedSortType,
                            'search': this.searchData,
                            'pagination': true 
                        })
                        .then((res) => {
                            this.storeMore = res.data.result.data;
                            this.nextPageUrl = res.data.result.next_page_url;
                            this.$Progress.finish();
                        }).catch((err) => {
                            console.log(err);
                            this.$Progress.finish();
                        })
                    } 

                }).catch((err) => {
                    console.log(err);
                    this.$Progress.finish();
                    this.loading=false;
                    this.afterAPI=true;
                });
            },

            async handleScroll(position) {               
                if (position !== "bottom") return; 
                await this.loadMore();
            },

            async loadMore() {
                if (this.storeMore.length != 0) {
                    var arr = this.employers;
                    this.storeMore.forEach(function(data) {
                        arr.push(data);
                    });
                    this.storeMore = [];
                    if (this.nextPageUrl != null) {
                        await service.getUrl(this.nextPageUrl, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID,
                            'sort-type': this.selectedSortType,
                            'search': this.searchData,
                            'pagination': true 
                        })
                        .then((res) => {
                            this.storeMore = res.data.result.data;
                            this.nextPageUrl = res.data.result.next_page_url;
                            this.$Progress.finish();
                        }).catch((err) => {
                            console.log(err);
                            this.$Progress.finish();
                        })
                    } else {
                        this.storeMore = [];
                    }

                }
                this.$nextTick(() => {
                    if (this.$refs.scrollContainer && this.$refs.scrollContainer._checkScroll) {
                        this.$refs.scrollContainer._checkScroll();
                    }
                });
            },

            addBatchNotify(emp) {
                // NOTE: `emp` is the client_employer row, so the EMPLOYER id is
                // emp.employer_id -- emp.id is the association id. The old code
                // pushed emp.id into selectedEmpId, which was never read by
                // anything (sendNotify was an empty stub).
                this.notifyEmployerId = emp.employer_id;
                this.notifyEmployerName = (emp.employer && emp.employer.name) ? emp.employer.name : '';

                var users = (emp.employer && emp.employer.employer_users) ? emp.employer.employer_users : [];
                this.notifyContacts = users.map(function (eu) {
                    var u = eu.user || {};
                    var name = ((u.first_name || '') + ' ' + (u.last_name || '')).trim();
                    return {
                        id: u.id,
                        email: u.email || '',
                        // the address is in the label on purpose -- the sender
                        // should see exactly where this is going
                        label: u.email ? (name ? name + ' <' + u.email + '>' : u.email)
                                       : (name || 'Unnamed contact') + ' (no email)'
                    };
                }).filter(function (c) { return c.id; });

                // default to everyone we can actually reach
                this.notifyRecipients = this.notifyContacts
                    .filter(function (c) { return c.email; })
                    .map(function (c) { return c.id; });

                this.notifyTab = 'email';
                this.notifyReplyTo = this.notifyDefaultReplyTo;
                this.notifySubject = '';
                this.emailContent = '';
                this.smsContent = '';
                this.$modal.show('batch-notify');
            },

            /**
             * #1710 — the client's configured Reply-To, used to prefill the Notify
             * From field. Read once on mount rather than per modal open; service.get
             * caches client/ URLs, so this is effectively free. A failure here is
             * non-fatal: the field just starts blank and the API falls back to the
             * configured address on its own.
             */
            loadNotifyDefaults() {
                if (!this.userClientID) {
                    return;
                }
                service.get('client/' + this.userClientID, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).then((res) => {
                    var settings = (res.data && res.data.result) ? res.data.result.settings : null;
                    var cfg = settings ? settings['notification-config'] : null;
                    if (cfg && cfg.email) {
                        this.notifyDefaultReplyTo = cfg.email;
                    }
                }).catch(() => {
                    // non-fatal -- see docblock
                });
            },

            /**
             * #1710 — actually send. This method used to be:
             *
             *     sendNotify() {
             *         // Not clear about api request
             *     },
             *
             * so Send silently did nothing. It now posts to
             * employer/{id}/notify, which resolves every recipient server-side
             * against this employer and the caller's tenant.
             */
            sendNotify() {
                if (this.notifySending) {
                    return;
                }
                if (!this.notifyRecipients.length) {
                    this.$message({ type: 'error', message: 'Select at least one contact to notify.' });
                    return;
                }
                if (!this.notifySubject || !this.notifySubject.trim()) {
                    this.$message({ type: 'error', message: 'A subject is required.' });
                    return;
                }
                if (!this.getPlainText(this.emailContent).trim()) {
                    this.$message({ type: 'error', message: 'Enter a message to send.' });
                    return;
                }
                if (this.hasValidationErrors()) {
                    this.$message({ type: 'error', message: 'Please correct the message before sending.' });
                    return;
                }

                this.notifySending = true;
                // relative path -- service.post prepends BASE_URL (/api/v2/), the
                // same way every other call in this component does
                service.post('employer/' + this.notifyEmployerId + '/notify', {
                    recipients: this.notifyRecipients,
                    subject: this.notifySubject,
                    body: this.emailContent,
                    // blank -> the API falls back to the configured Reply-To
                    reply_to: this.notifyReplyTo
                }, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID,
                }).then((res) => {
                    this.notifySending = false;
                    var d = res.data || {};
                    if (d.status_code == '1') {
                        this.$message({ type: 'success', message: d.status_message || 'Notification sent.' });
                        this.closeBatchNotify();
                    } else {
                        // never report success for a send that did not happen
                        this.$message({ type: 'error', message: this.firstNotifyError(d) });
                    }
                }).catch((err) => {
                    this.notifySending = false;
                    var d = (err && err.response && err.response.data) ? err.response.data : {};
                    this.$message({ type: 'error', message: this.firstNotifyError(d) });
                });
            },

            /**
             * The API returns a MessageBag on a 422 and a plain string otherwise
             * -- the same shape that made /addEmployer show a blank toast (!505).
             */
            firstNotifyError(d) {
                var fallback = 'The notification could not be sent.';
                var m = d ? d.status_message : null;
                if (!m) return fallback;
                if (typeof m === 'string') return m;
                if (Array.isArray(m)) return m[0] || fallback;
                var msgs = [];
                Object.keys(m).forEach(function (k) {
                    var v = m[k];
                    if (Array.isArray(v)) { msgs = msgs.concat(v); }
                    else if (typeof v === 'string') { msgs.push(v); }
                });
                return msgs.length ? msgs.join(' ') : fallback;
            },

            closeBatchNotify() {
                this.$modal.hide('batch-notify');
            },

            attachmentAdded(event) {
                console.log(event);
            },

            validateContent(fieldName, value) {
                if (!this.error) {
                    this.$set(this, 'error', {});
                }
                
                this.$set(this.error, fieldName, {
                    hasError: false,
                    message: ''
                });
                
                const plainText = this.getPlainText(value);
                if (plainText.trim().length > 0) {
                    // #1952 — ed, 2026-09-30: "a, show it". Name every offender and where it
                    // is; never rewrite what the user pasted.
                    const problems = findContentProblems(plainText);
                    if (problems.length > 0) {
                        this.$set(this.error, fieldName, {
                            hasError: true,
                            problems: problems,
                            message: describeContentProblems(problems)
                        });
                    }
                }
            },
    
            getPlainText(html) {
                return stripHtml(html);   // #1952 — shared, was duplicated in ten files
            },
    
            // #1952 — one shared rule set (src/contentRules.js). This used to carry
            // four patterns inline, duplicated verbatim across ten components; two of
            // them rejected indentation, tabs, ---- dividers and ellipses.
            containsInvalidContent(text) {
                return findContentProblems(text).length > 0;
            },

            hasValidationErrors() {
                if (!this.error) return false;
                return Object.values(this.error).some(error => error.hasError === true);
            },
        },
        beforeMount() {
            this.getEmployerList();
            this.loadNotifyDefaults();
        }
    }

</script>

<style scoped>
.err-msg {
    margin: 2px;
    color: red
}
.employer-address {
    font-size: 0.9em;
    color: #777777;
    line-height: 1.3;
    margin-top: 2px;
}
.admin-tag {
    margin-left: 4px;
    font-size: 0.85em;
    font-weight: 600;
    color: #3c8dbc;
    white-space: nowrap;
}

.email-line {
    margin: 0 0 2px 0;
}
.email-copy-icon {
    margin-left: 6px;
    color: #888888;
    text-decoration: none !important;
    cursor: pointer;
    opacity: 0.65;
}
.email-copy-icon:hover {
    opacity: 1;
    color: #222222;
}

/* #1706 — the per-owner label inside the Phone column. The global
   `.o-accordion-subtext span` rule is meant for the column HEADER ("Phone:"),
   so without this the owner labels render as if each were another header. */
/* Ed 2026-08-15: the Notify column had "loads of space" -- it holds a single
   word and an icon, but .o-calls-table is `display: table` with AUTO layout,
   which hands every column a share of the leftover width regardless of how
   little content it has.

   `width: 1%` + nowrap is the standard table idiom for "shrink to fit": the
   browser cannot honour 1% without breaking min-content, so it collapses the
   cell to exactly its content and redistributes the surplus to the columns that
   asked for more -- here, Phone. */
.notify-from-hint {
    display: block;
    font-size: 0.85em;
    color: #888888;
    margin-top: 2px;
}
.notify-recipients {
    width: 100%;
}

.notify-col {
    width: 1%;
    white-space: nowrap;
}

/* same shrink-to-fit idiom as notify-col -- see the comment there */
.flags-col {
    width: 1%;
    white-space: nowrap;
}
.flag-line {
    display: flex;
    align-items: center;
    gap: 5px;
    margin: 0 0 2px 0;
    line-height: 1.4;
}
.flag-line input[type="checkbox"] {
    margin: 0;
    /* read-only, but disabled inputs render washed out and are easy to misread
       as "unknown" rather than "not set", so keep them legible */
    opacity: 1;
    cursor: default;
}
.flag-label {
    font-size: 0.9em;
    color: #666666;
}

/* Ed 2026-08-15: one phone per line -- "Company: (503) 555-0142" was wrapping
   onto two lines in a narrow column. Same treatment employeeList already uses
   for its P:/C: rows (tablet-override.css .o-phone-cell .o-phone-row): a flex
   row, which does not wrap between items, with the label pinned at its natural
   width. nowrap on the number stops it breaking mid-digits.

   This is also what FINDS the space rather than just clipping: .o-calls-table is
   `display: table` with auto layout, so making these rows unbreakable raises the
   Phone column's min-content width and the browser reallocates to it from the
   columns that can still wrap (Email, which is long and wraps happily). The
   first cell is pinned at 325px in style.css and is not touched. */
.phone-line {
    display: flex;
    align-items: baseline;
    gap: 4px;
    line-height: 1.5;
    margin: 0 0 2px 0;
}
.phone-owner-label {
    flex: 0 0 auto;
    display: inline !important;
    margin: 0 !important;
    font-weight: 600;
    font-size: 0.92em;
    color: #666666;
}
/* reclaim the 5px-a-side the shared link style adds -- 10px per line, and the
   label already provides the separation */
.phone-line .phone-number-display {
    padding: 0;
    white-space: nowrap;
}
.phone-number-display{
    padding: 5px;
    cursor: pointer;
    color: #222222;
    text-decoration: none !important;
}
</style>
